<template>
  <v-data-table hide-actions :headers="headers" :items="summary.items">
    <template slot="items" slot-scope="{ item }">
      <tr>
        <td class="font-weight-bold">{{ item.standard }}</td>
        <td class="font-weight-bold">{{ item.no_of_standard }}</td>
        <td class="font-weight-bold">{{ item.total_score }}</td>
        <td class="font-weight-bold">{{ item.qualifying_score }}</td>
        <td class="font-weight-bold">{{ item.score_obtained }}</td>
        <td class="font-weight-bold" :class="item.status">{{ item.status }}</td>
      </tr>
    </template>
    <template slot="footer">
      <tr>
        <td class="font-weight-bold">Award of Best Practice</td>
        <td colspan="5" class="font-weight-bold">
          <span>{{ summary.best_award_sections }}</span>
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">Excellence Award</td>
        <td colspan="5" class="font-weight-bold">
          <span>{{ summary.excellence_award }}</span>
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">Summary</td>
        <td colspan="5">
          <strong>{{ summary.summary }}</strong>
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">Evaluation Team Recommendations</td>
        <td colspan="5" class="font-weight-bold">
          <span>{{ summary.recommendation }}</span>
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">AICS Board Decision</td>
        <td colspan="5" class="font-weight-bold">
          <span>{{ summary.decision }}</span>
        </td>
      </tr>
      <tr v-if="summary.decision == 'Certified'">
        <td class="font-weight-bold">Certificate Issue Date</td>
        <td colspan="5" class="font-weight-bold">{{ summary.issue_date }}</td>
      </tr>
      <tr v-if="summary.decision == 'Certified'">
        <td class="font-weight-bold">Certificate Expiration Date</td>
        <td colspan="5" class="font-weight-bold">{{ summary.expire_date }}</td>
      </tr>
      <tr v-if="summary.decision == 'Deferred'">
        <td class="font-weight-bold">Remminder Date</td>
        <td colspan="5" class="font-weight-bold">
          {{ summary.reminder_date }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ["summary"],
  name: "scoreCardSummary",

  computed: {
    headers: vm => [
      { text: vm.$t("standards"), value: "standard", sortable: false },
      {
        sortable: false,
        value: "no_of_standard",
        text: vm.$t("no_of_standard")
      },
      {
        sortable: false,
        value: "total_score",
        text: vm.$t("total_score")
      },
      {
        sortable: false,
        value: "qualifying_score",
        text: vm.$t("qualifying_score")
      },
      {
        sortable: false,
        value: "score_obtained",
        text: vm.$t("score_obtained")
      },
      {
        value: "status",
        sortable: false,
        text: vm.$t("status")
      }
    ]
  }
};
</script>
